import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type AssignmentRestrictionFragment = { type: Types.AssignmentRestrictionTypeEnum, roleIds?: Array<string> | null };


export type AssignmentRestrictionFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const AssignmentRestrictionFragmentDoc = /*#__PURE__*/ gql`
    fragment AssignmentRestriction on AssignmentRestrictionType {
  type
  roleIds
}
    `;